module.exports = __webpack_public_path__ + "img/income_term_filled.3e8fdfe.svg";